<div
  class="mx-auto max-w-screen-xl px-4 py-8 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-24"
>
  <div class="flex flex-col items-start justify-center gap-4 md:flex-row">
    <div class="flex flex-1 flex-col items-center">
      <div class="w-full max-w-lg">
        <div
          class="shadow rounded-2xl border border-secondary-border bg-white p-8"
        >
          <div class="mb-4">
            <h1 class="mb-2 text-3xl font-medium text-primary-text md:text-4xl">
              {{ 'pages.organization.create.title' | translate }}
            </h1>
            <p class="text-sm text-secondary-text md:text-base">
              {{ 'pages.organization.create.description' | translate }}
            </p>
          </div>
          <form
            class="flex flex-col"
            [formGroup]="organizationForm"
            (submit)="createOrganization()"
          >
            @for (field of fields; track field.label) {
              <div class="my-2 flex flex-col gap-2">
                <label
                  class="text-base font-medium text-primary-text"
                  [for]="field.label"
                >
                  <div class="flex items-end gap-2">
                    <span>{{
                      'pages.organization.create.' + field.label + '.title'
                        | translate
                    }}</span>
                    @if (field.required === false) {
                      <span class="text-xs text-secondary-text">
                        ({{ 'pages.organization.create.optional' | translate }})
                      </span>
                    }
                  </div>
                  @if (field.select) {
                    <select
                      class="select w-full max-w-lg rounded-lg border border-gray-300 px-3 py-2 focus:ring-2 focus:ring-blue-200 focus:outline-none"
                      [formControlName]="field.label"
                      [id]="field.label"
                    >
                      <option [ngValue]="null" disabled>
                        {{
                          'pages.organization.create.' +
                            field.label +
                            '.placeholder' | translate
                        }}
                      </option>
                      @for (country of field.select | orderBy; track country) {
                        <option [ngValue]="country.value">
                          {{ country.label }}
                        </option>
                      }
                    </select>
                  } @else {
                    <input
                      class="input w-full max-w-lg rounded-lg border border-gray-300 px-3 py-2 focus:ring-2 focus:ring-blue-200 focus:outline-none"
                      [formControlName]="field.label"
                      [id]="field.label"
                      [ngClass]="{
                        'border-red-400 ring-2 ring-red-200':
                          organizationForm.get(field.label)?.dirty &&
                          organizationForm.get(field.label)?.invalid,
                      }"
                      [placeholder]="
                        'pages.organization.create.' +
                          field.label +
                          '.placeholder' | translate
                      "
                      type="text"
                    />
                  }
                </label>
              </div>
            }
            <div
              class="mt-6 flex flex-col rounded-xl border border-secondary-border bg-slate-50 p-4"
            >
              <div class="flex items-end gap-2">
                <h2 class="text-base font-medium text-primary-text">
                  {{ 'pages.organization.create.domains.title' | translate }}
                </h2>
                <span class="text-xs text-secondary-text">
                  ({{ 'pages.organization.create.optional' | translate }})
                </span>
              </div>
              <p class="mt-2 text-sm leading-relaxed text-secondary-text">
                {{
                  'pages.organization.create.domains.description' | translate
                }}
              </p>

              <div class="mt-4 flex flex-col gap-3">
                @for (domainControl of domainControls(); track $index) {
                  <div class="flex flex-col gap-2 sm:flex-row sm:items-center">
                    <div class="flex-1">
                      <input
                        class="input w-full rounded-lg border border-gray-300 px-3 py-2 focus:ring-2 focus:ring-blue-200 focus:outline-none"
                        [formControl]="domainControl"
                        [id]="'domain-' + $index"
                        [attr.aria-label]="
                          'pages.organization.create.domains.title' | translate
                        "
                        [ngClass]="{
                          'border-red-400 ring-2 ring-red-200':
                            shouldShowDomainErrors(domainControl),
                        }"
                        [placeholder]="
                          'pages.organization.create.domains.placeholder'
                            | translate
                        "
                        type="text"
                      />

                      @if (shouldShowDomainErrors(domainControl)) {
                        <p class="mt-2 text-sm text-error-text">
                          @if (domainControl.hasError('required')) {
                            {{ 'common.fieldValidation.required' | translate }}
                          } @else {
                            {{
                              'pages.organization.create.domains.invalid'
                                | translate
                            }}
                          }
                        </p>
                      }
                    </div>

                    <button
                      class="btn-secondary btn"
                      [disabled]="isSending()"
                      (click)="removeDomain($index)"
                      type="button"
                    >
                      {{
                        'pages.organization.create.domains.removeButton'
                          | translate
                      }}
                    </button>
                  </div>
                }

                <button
                  class="btn-secondary btn sm:w-fit"
                  [disabled]="isSending()"
                  (click)="addDomain()"
                  type="button"
                >
                  {{
                    'pages.organization.create.domains.addButton' | translate
                  }}
                </button>
              </div>
            </div>
            <!-- Error State -->
            @if (error() && !isSending()) {
              <div
                class="mt-4 rounded-lg border border-red-200 bg-red-50 p-4 text-sm text-red-700"
              >
                {{ error() | translate }}
              </div>
            }
            <div class="mt-4">
              <dhp-submit-button
                class="w-full"
                [disabled]="organizationForm.invalid"
                [labelKey]="'pages.organization.create.createSubmit'"
                [sendingLabelKey]="'pages.organization.create.createSending'"
                [sending]="isSending()"
              ></dhp-submit-button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
